import OrderService from "../../services/OrderService";
import AgentJobsService from "../../services/AgentJobsService";
import download from "downloadjs";
import FormService from "../../services/FormService";

const usedOrderIds = new Set();

function generateUniqueOrderId() {
  let newId;
  do {
    newId = Math.floor(Math.random() * 1000000);
  } while (usedOrderIds.has(newId));
  usedOrderIds.add(newId);
  return newId;
}

export default {
  namespaced: true, // all the state, mutations, actions, getters in this module is unique to this store module
  state() {
    return {
      Orders: [],
      Cart: { OrderLines: [] },
      OpenOrders: 0,
      CartTotal: 0,
      TaxPercent: 0,
      OrdersToAprove: [],
      isCartModelOpen: false,
      minOrderSum: 0,
      shippingTiers: [],
      isCartModelOpenHeader: false, // Add this new state property,
      NumberOfDaysToDelivery: 3,
    };
  },
  mutations: {
    setNumberOfDaysToDelivery(state, NumberOfDaysToDelivery) {
      state.NumberOfDaysToDelivery = NumberOfDaysToDelivery;
    },
    setCartModel(state, value) {
      state.isCartModelOpen = value;
    },
    setOrdersToAprove(state, OrdersToAprove) {
      state.OrdersToAprove = OrdersToAprove;
    },
    setTaxPercent(state, TaxPercent) {
      state.TaxPercent = TaxPercent;
    },
    clearCart(state) {
      state.Cart.OrderLines = [];
    },
    addProductToCart(state, line) {
      state.Cart.OrderLines.unshift({
        quant: line.quant,
        ordi: line.ordi,
        Part: { ...line.Part },
      });
    },
    removeProductFromCart(state, productIndex) {
      state.Cart.OrderLines.splice(productIndex, 1);
    },
    updateProductInCart(state, obj) {
      var { productIndex, product } = obj;
      var line = state.Cart.OrderLines[productIndex];
      line.quant = product.quant;
      line.id = product.id;
      line.ordi = product?.ordi;
      line.Part.quant = product.Part;
      state.Cart.OrderLines[productIndex].Part.quant = product.quant;
    },
    //old nirotek code
    setOrders(state, userObj) {
      state.Orders = userObj;
      this.commit("Orders/setOpenOrders");
    },
    setOrder(state, order) {
      const index = state.Orders.findIndex((ord) => ord.ord === order.ord);
      if (typeof index !== "undefined") {
        state.Orders[index] = order;
      } else {
        state.Orders.push(order);
      }
      this.commit("Orders/setOpenOrders");
    },
    setOrderLine(state, newOrderLine) {
      const index = state.Orders.findIndex(
        (ord) => ord.ord === newOrderLine.ord
      );
      console.log("the index");
      console.log(index);

      if (typeof index !== "undefined") {
        //state.Orders[index].OrderLines[newOrderLine.line - 1] = newOrderLine;
        for (let line of state.Orders[index].OrderLines) {
          if (line.id === newOrderLine.id) {
            line = {
              ...newOrderLine,
            };
          }
        }
      }
      this.commit("Orders/setOpenOrders");
    },
    removeLine(state, data) {
      if (data.ord > 0) {
        const index = state.Orders.findIndex((ord) => ord.ord === data.ord);
        const ordiIndex = state.Orders[index].OrderLines.findIndex(
          (line) => line.id === data.id
        );
        state.Orders[index].OrderLines.splice(ordiIndex, 1);
        this.commit("Orders/setOpenOrders");
      } else {
        const cartIndex = state.Cart.OrderLines.findIndex(
          (line) => line.id === data.id
        );
        state.Cart.OrderLines.splice(cartIndex, 1);
        this.commit("Orders/setCartTotal");
      }
    },
    setCart(state, userObj) {
      if (Object.keys(userObj).length === 0) return;
      state.Cart = userObj;
      this.commit("Orders/setCartTotal");
    },
    setCartTotal(state) {
      let total = 0;

      state.Cart?.OrderLines?.forEach((line) => {
        total += line.quant;
      });
      state.CartTotal = total;
      if (total === 0) {
        this.commit("setIsOpenMobileSideBar", false, { root: true });
      }
    },
    setOpenOrders(state) {
      let total = 0;
      state.Orders.forEach((order) => {
        if (order?.Status?.activeorder) {
          total += 1;
        }
      });
      state.OpenOrders = total;
    },
    setCartModelHeader(state, value) {
      state.isCartModelOpenHeader = value;
    },
    setMinOrderSum(state, minOrderSum) {
      state.minOrderSum = minOrderSum;
    },
    setShippingTiers(state, shippingTiers) {
      state.shippingTiers = shippingTiers;
    },
  },
  actions: {
    async submitQuotationForm(context, data) {
      try {
        const response = await FormService.submitQuotationForm(data);
        return response;
      } catch (error) {
        console.log(error);
        context.dispatch(
          "ShowToast",
          {
            status: "error",
            message: error?.response?.data?.message ?? "שגיאה בשליחת הטופס",
          },
          { root: true }
        );
      }
    },
    async getNumberOfDaysToDelivery(context) {
      try {
        const response = await OrderService.getnumberOfDaysToDelivery();
        context.commit("setNumberOfDaysToDelivery", response.data.days);
      } catch (error) {
        console.log(error);
      }
    },
    async getUserCart(context) {
      // const isUserGuest = context.rootGetters["AuthModule/isUserGuest"];
      // console.log("isUserGuest");
      // console.log(isUserGuest);
      const guestCart = localStorage.getItem("guestCart");

      if (!context.rootGetters["AuthModule/isAuthenticated"]) {
        if (guestCart) {
          // Get cart from localStorage for guest users
          const savedCart = guestCart;
          const cart = savedCart ? JSON.parse(savedCart) : { OrderLines: [] };
          context.commit("setCart", cart);
        }
      } else {
        // Get cart from API for logged in users
        try {
          const userCart = await OrderService.getUserCart();
          if (userCart?.data) {
            context.commit("setCart", userCart.data);
          }
          // Fetch minOrderSum after getting user cart or when the module is initialized
          context.dispatch("fetchMinOrderSum");
        } catch (error) {
          console.log(error);
        }
      }
    },
    async setCartModel(context, value) {
      context.commit("setCartModel", value);
    },
    async getOrdersToAprove(context) {
      const response = await OrderService.getOrdersToAprove();
      context.commit("setOrdersToAprove", response.data);
    },
    async getAwatingOrders() {
      const response = await OrderService.getAwatingOrders();
      return response.data;
    },
    async getTaxPercent(context) {
      const response = await OrderService.getTaxPercent();
      context.commit("setTaxPercent", response.data?.taxpercent);
    },
    async getOrders(context, query) {
      const response = await OrderService.getOrders(query);
      context.commit("setOrders", response.data.orders);
      return response.data.count;
      // context.commit("setCart", response.data.cart);
    },
    async getOrder(context, ord) {
      const response = await OrderService.getOrder(ord);
      return response.data;
      // context.commit("setCart", response.data.cart);
    },
    async updateQuantOfPartByCart(context, { products, modifyParts = true }) {
      // Step 1: Create a hash map for the products array
      const productMap = {};
      products.forEach((part) => {
        productMap[part.part] = part;
      });

      // Step 2: Update quantities based on OrderLines

      context.state.Cart?.OrderLines?.forEach((line) => {
        const part = productMap[line.Part.part];
        if (part) {
          part.quant = line.quant;
          part.ordi = line.ordi;
        }
      });
      //convert the object back to array
      var partsArray = Object.keys(productMap).map((key) => productMap[key]);

      // updated products array
      if (modifyParts)
        context.commit("Parts/setParts", partsArray, { root: true });

      return partsArray;
    },
    async addProductToCart(context, product) {
      var productIndex = context.getters.getPartIndexById(product.ordi);
      if (productIndex !== -1) {
        context.commit("updateProductInCart", { productIndex, product });
      } else {
        context.commit("addProductToCart", product);
      }
      context.commit("setCartTotal");
    },
    async clearStoreCart(context) {
      context.commit("clearCart");
    },
    async clearCart(context) {
      const isUserGuest = context.rootGetters["AuthModule/isUserGuest"];

      if (isUserGuest) {
        // Clear localStorage cart for guest users
        localStorage.removeItem("guestCart");
        context.commit("clearCart");
        context.commit("setCartTotal");
      } else {
        // Clear cart via API for logged in users
        try {
          await OrderService.clearCart();
          context.dispatch(
            "Parts/restAllQuantity",
            context.state.Cart.OrderLines,
            {
              root: true,
            }
          );
          context.commit("clearCart");
          context.commit("setCartTotal");
        } catch (err) {
          console.log(err);
        }
      }
    },
    async removeProductFromCart(context, product) {
      const isUserGuest = context.rootGetters["AuthModule/isUserGuest"];
      const productIndex = context.getters.getPartIndexById(product.ordi);

      if (isUserGuest) {
        // Remove from localStorage cart for guest users
        if (productIndex !== -1) {
          context.commit("removeProductFromCart", productIndex);
          context.commit("setCartTotal");
          // Update localStorage
          localStorage.setItem("guestCart", JSON.stringify(context.state.Cart));
        }
      } else {
        // Remove via API for logged in users
        await OrderService.removeOrderLine(product);
        if (productIndex !== -1) {
          context.dispatch("Parts/restQuantityByPart", product, { root: true });
          context.commit("removeProductFromCart", productIndex);
          context.commit("setCartTotal");
        }
      }
    },
    //old nirotek code
    async printDelivery(context, docNum) {
      this.dispatch("startLoading", null, { root: true });
      try {
        let userLang = context.rootState.AuthModule.user.language;

        let res =
          userLang === "he"
            ? await OrderService.printDelivery(docNum)
            : await OrderService.printDeliveryEnglish(docNum);

        if (res) {
          context.dispatch(
            "stopLoading",
            { status: "success", message: "הורדה הושלמה" },
            { root: true }
          );
        }

        download(
          res.data,
          `https://app-prod.nirotek.com/netfiles/1450130p1364427430.pdf`,
          res.headers["content-type"]
        );

        return res;
      } catch (err) {
        console.log("error printOrder from Orders.js:", err);
        context.dispatch(
          "stopLoading",
          { status: "error", message: "שגיאה בניסיון הצגת הזמנה" },
          { root: true }
        );
      }
    },
    async printOrder(context, ordName) {
      this.dispatch("startLoading", null, { root: true });
      try {
        let res = await OrderService.printOrder(ordName);
        if (res) {
          context.dispatch(
            "stopLoading",
            { status: "success", message: "מציג הזמנה" },
            { root: true }
          );
        }

        download(
          res.data,
          `https://app-prod.nirotek.com/netfiles/1450130p1364427430.pdf`,
          res.headers["content-type"]
        );

        return res;
      } catch (err) {
        console.log("error printOrder from Orders.js:", err);
        context.dispatch(
          "stopLoading",
          { status: "error", message: "שגיאה בניסיון הצגת הזמנה" },
          { root: true }
        );
      }
    },

    async updateCart(context, line) {
      const isUserGuest = context.rootGetters["AuthModule/isUserGuest"];

      if (isUserGuest) {
        // Update cart in localStorage for guest users
        const productIndex = context.getters.getPartIndexById(line.ordi);
        if (productIndex !== -1) {
          context.commit("updateProductInCart", {
            productIndex,
            product: line,
          });
        } else {
          context.commit("addProductToCart", {
            ...line,
            ordi: generateUniqueOrderId(),
          });
        }
        // Save to localStorage
        localStorage.setItem("guestCart", JSON.stringify(context.state.Cart));
      } else {
        // Update cart via API for logged in users
        const res = await OrderService.updateCart({ line });
        const productIndex = context.getters.getPartIndexById(res.data.ordi);
        if (productIndex !== -1) {
          context.commit("updateProductInCart", {
            productIndex,
            product: res.data,
          });
        } else {
          context.commit("addProductToCart", res.data);
        }
      }
    },

    async updateLinesCart(context, lines) {
      var res = await OrderService.updateLinesCart({ lines });
      // res.data is now an array of updated lines
      res.data.forEach((updatedLine) => {
        var productIndex = context.getters.getPartIndexById(updatedLine.ordi);
        if (productIndex !== -1) {
          context.commit("updateProductInCart", {
            productIndex,
            product: updatedLine,
          });
        } else {
          context.commit("addProductToCart", updatedLine);
        }
      });
    },

    updateOrders(context, data) {
      context.commit("setOrders", data);
    },
    async sendOrder(context, order) {
      this.dispatch("startLoading", null, { root: true });
      console.log("order to send:");
      console.log(order);
      try {
        const response = await OrderService.sendOrder(order);
        context.commit("clearCart");
        return response.data;
      } catch (error) {
        console.log("error updateing order:", error);
        context.dispatch(
          "ShowToast",
          {
            status: "error",
            message:
              error.response.data.error ??
              "ארעה שגיאה, מומלץ לרענן את הדף ולנסות שוב",
          },
          { root: true }
        );
        return error;
      } finally {
        context.dispatch("stopLoading", null, { root: true });
      }
    },
    async removeOrderLine({ commit }, data) {
      try {
        await OrderService.removeOrderLine(data);
      } catch (err) {
        console.log("error remove line:" + err);
      }
      commit("removeLine", data);
    },
    async updateOrder(context, data) {
      this.dispatch("startLoading", null, { root: true });

      try {
        context.commit("setOrder", data);
        context.commit("setOpenOrders");
        const res = await AgentJobsService.updateOrder(data);
        console.log(res);
        context.dispatch(
          "stopLoading",
          { status: "success", message: "השינויים נשמרו בהצלחה" },
          { root: true }
        );
      } catch (error) {
        console.log("error updateing order:", error);
        context.dispatch(
          "stopLoading",
          { status: "error", message: "ההזמנה נשלחה לביצוע אך לא עודכנה באתר" },
          { root: true }
        );
      }
    },
    async setCartModelHeader(context, value) {
      context.commit("setCartModelHeader", value);
    },
    async fetchMinOrderSum(context) {
      try {
        const response = await OrderService.getMinOrderSum();
        context.commit("setMinOrderSum", response.data.minOrderSum);
      } catch (error) {
        console.log(error);
      }
    },
    async fetchShippingTiers(context) {
      try {
        const response = await OrderService.getShippingTiers();
        context.commit("setShippingTiers", response.data);
      } catch (error) {
        console.log(error);
      }
    },
  },
  getters: {
    getNumberOfDaysToDelivery(state) {
      return state.NumberOfDaysToDelivery;
    },
    getTotalCartPackges(state) {
      return state.Cart.OrderLines.reduce((acc, line) => {
        if (line?.Part?.package > 0) {
          return acc + line.quant / line.Part.package;
        }
        return acc + 0;
      }, 0);
    },
    getMinOrderSum(state) {
      return state.minOrderSum;
    },
    getIsCartModelOpen(state) {
      return state.isCartModelOpen;
    },
    getOrdersToAprove(state) {
      return state.OrdersToAprove;
    },
    getCartTotalPrice(state) {
      let total = 0;
      for (let orderLine of state.Cart.OrderLines) {
        total +=
          (orderLine?.Part.discountPrice > 0
            ? orderLine.Part.discountPrice
            : orderLine.Part.originPrice) * orderLine.quant;
      }
      return total;
    },
    getCartDiscount(state, getters, rootState, rootGetters) {
      const user = rootGetters["AuthModule/getUser"];
      if (user?.Customer?.priceListId && user.Customer.discountPrecent > 0) {
        return user.Customer.discountPrecent;
      }
      return 0;
    },
    getCartOrderLinesNumber(state) {
      return state.Cart.OrderLines.length;
    },
    getCartOrderLinesUnitsNumber(state) {
      return (
        state.Cart?.OrderLines?.reduce(
          (sum, line) =>
            sum +
              (line?.Part?.package
                ? line.Part.package * (line.quant / line.Part.package)
                : line.quant) ?? 1,
          0
        ) || 0
      );
    },
    getOrderStatuses(state) {
      let statusList = {};
      if (!state.Orders) return statusList;
      for (let order of state.Orders) {
        if (typeof statusList[order?.Status?.statdes] === "undefined")
          statusList[order?.Status?.statdes] = {
            id: order?.Status?.statdes,
            name: order?.Status?.statusname,
            count: 0,
            enName: order?.Status?.estatusname,
          };
        statusList[order?.Status?.statdes].count++;
      }
      return statusList;
    },
    getPartIndexById: (state) => (ordi) => {
      return state.Cart.OrderLines.findIndex((line) => {
        return line.ordi === ordi;
      });
    },
    getTotalCartBeforeVAT(state) {
      let total = 0;
      for (let orderLine of state.Cart.OrderLines) {
        total +=
          (orderLine?.Part.discountPrice > 0
            ? orderLine.Part.discountPrice
            : orderLine.Part.originPrice) * orderLine.quant;
      }
      // calculate price Before VAT
      return total;
    },
    getShippingTiers(state) {
      return state.shippingTiers;
    },
    // Preview-only shipping fee matched against the pre-VAT cart subtotal.
    // Mirrors the server's ShippingTierService.getShippingCost rule; the
    // server stays authoritative at order submission.
    getShippingCost(state, getters, rootState, rootGetters) {
      // No shipping at all unless shippingRivhitItemId is configured — otherwise
      // the fee would never actually be charged/itemized server-side either.
      if (!rootGetters.isShippingEnabled) return 0;
      // Empty cart → no shipping (otherwise a subtotal of 0 still matches the
      // lowest tier and leaks a shipping fee + its VAT into the summary).
      if (!state.Cart?.OrderLines?.length) return 0;

      const subtotal = getters.getTotalCartBeforeVAT;
      const tiers = (state.shippingTiers || []).filter((t) => t.active);

      let matched = null;
      for (const tier of tiers) {
        const min = tier.minAmount ?? 0;
        const max = tier.maxAmount;
        if (
          subtotal >= min &&
          (max === null || max === undefined || subtotal <= max)
        ) {
          if (!matched || min >= matched.minAmount) {
            matched = tier;
          }
        }
      }
      return matched ? matched.price : 0;
    },
    getCartTotalWithShipping(state, getters) {
      return getters.getTotalCartBeforeVAT + getters.getShippingCost;
    },
    // Progress toward the free-shipping goal: how much more the customer must
    // spend before shipping becomes free. The free threshold is either an
    // explicit free tier (price 0) or the point just above the highest
    // charging tier (above which no tier matches and shipping defaults to 0).
    // Returns null when there is no reachable free-shipping goal.
    getShippingProgress(state, getters, rootState, rootGetters) {
      // No shipping goal to show unless shippingRivhitItemId is configured.
      if (!rootGetters.isShippingEnabled) return null;
      // No items → no shipping goal to show.
      if (!state.Cart?.OrderLines?.length) return null;

      const subtotal = getters.getTotalCartBeforeVAT;
      const currentCost = getters.getShippingCost;
      const tiers = (state.shippingTiers || []).filter((t) => t.active);

      if (!tiers.length) return null;

      // Already paying nothing → free shipping is in effect.
      if (currentCost === 0) {
        return { reachedFree: true, remaining: 0, percent: 100 };
      }

      const freeTiers = tiers.filter((t) => t.price === 0);
      const paidTiers = tiers.filter((t) => t.price > 0);

      let freeThreshold;
      if (freeTiers.length) {
        // Explicit free tier: its lowest entry price.
        freeThreshold = Math.min(...freeTiers.map((t) => t.minAmount ?? 0));
      } else {
        // No free tier — shipping becomes free above the top charging tier.
        // If any charging tier is open-ended (no maxAmount), free is never
        // reached, so there is no goal to show.
        const hasOpenEnded = paidTiers.some(
          (t) => t.maxAmount === null || t.maxAmount === undefined
        );
        if (hasOpenEnded) return null;
        freeThreshold = Math.max(...paidTiers.map((t) => t.maxAmount));
      }

      const remaining = Math.max(0, freeThreshold - subtotal);
      const percent =
        freeThreshold > 0
          ? Math.min(100, (subtotal / freeThreshold) * 100)
          : 100;

      return {
        reachedFree: false,
        remaining,
        percent,
        freeThreshold,
      };
    },
    getLineByPart: (state) => (part) => {
      var line = state.Cart.OrderLines.find((line) => {
        return line.Part.part === part;
      });
      if (line) {
        return line.ordi;
      } else {
        return 0;
      }
    },
    //old nirotek code
    getOrders(state) {
      return state.Orders;
    },
    getOrder: (state) => (ord) => {
      if (ord == "cart") {
        return state.Cart;
      } else {
        for (let order in state.Orders)
          if (state.Orders[order].ord == ord) return state.Orders[order];
      }
    },
    getTaxPercent(state, getters, rootState, rootGetters) {
      const user = rootGetters["AuthModule/getUser"];
      if (user?.Customer?.isVatFree) {
        return 0;
      }
      return state.TaxPercent;
    },
    getCart(state) {
      return state.Cart;
    },
    getCartTotal(state) {
      return state.CartTotal;
    },
    getOpenOrders(state) {
      return state.OpenOrders;
    },
    getTotalCartSavings(state, getters) {
      const generalCartDiscount = getters.getCartDiscount;
      if (generalCartDiscount === 0) {
        // return state.Cart.OrderLines.reduce((total, orderLine) => {
        //   if (orderLine?.Part?.discountPrice > 0) {
        //     const saving =
        //       (orderLine.Part.originPrice - orderLine.Part.discountPrice) *
        //       orderLine.quant;
        //     return total + saving;
        //   }
        //   return total;
        // }, 0);
        return 0;
      } else {
        // apply the general cart discount at the end
        return getters.getCartTotalPrice * (generalCartDiscount / 100);
      }
    },
    getIsCartModelOpenHeader(state) {
      return state.isCartModelOpenHeader;
    },
  },
};
